import { render } from "./EmisionAsistente.vue?vue&type=template&id=4d802302&scoped=true"
import script from "./EmisionAsistente.vue?vue&type=script&lang=js"
export * from "./EmisionAsistente.vue?vue&type=script&lang=js"

import "./EmisionAsistente.vue?vue&type=style&index=0&id=4d802302&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d802302"]])

export default __exports__